import React from "react";
import { Form, Input, Select, Tooltip } from "antd";
import { getDigitsOnly } from "../../../utils";

const { Option } = Select;

interface DealGridFormProps {
	form: any;
	wholeData: {
		channelData: Array<{ key: string; id: string; name: string; active: boolean }>;
		partnerData: Array<{ key: string; id: string; name: string; active: boolean }>;
		platformData: Array<{ key: string; id: string; name: string; active: boolean }>;
		territoryData: Array<{ key: string; id: string; name: string; active: boolean }>;
	};
}

const DealGridForm: React.FC<DealGridFormProps> = ({ form, wholeData }) => {
	const { channelData, partnerData, platformData, territoryData } = wholeData;

	return (
		<>
			<Form.Item
				label="ID"
				name="deal_parent"
				rules={[{ required: true, message: "Please input the Deal Parent!" }]}
			>
				<Input onChange={e => form.setFieldValue("deal_parent", getDigitsOnly(e.target.value))} />
			</Form.Item>

			<Form.Item
				label="Platform"
				name="platform"
				rules={[{ required: true, message: "Please select a platform!" }]}
			>
				<Select placeholder="Select a platform" allowClear showSearch>
					{platformData.map(platform => (
						<Option key={platform.key} value={platform.name}>
							{platform.name}
						</Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label="Partner"
				name="partner"
				rules={[{ required: true, message: "Please select a partner!" }]}
			>
				<Select allowClear showSearch placeholder="Select a partner">
					{partnerData.map(partner => (
						<Option key={partner.key} value={partner.name}>
							{partner.name}
						</Option>
					))}
				</Select>
			</Form.Item>
			
			<Form.Item label="Territory" name="territory">
				<Select
					allowClear
					showSearch
					placeholder="Select a territory"
					onChange={value => {
						const [id] = value?.split("_") ?? [];
						id ? form.setFieldValue("territory_id", id) : form.resetFields(["territory_id"]);
					}}
				>
					{territoryData.map(territory => (
						<Option key={territory.key} value={`${territory.id}_${territory.name}`}>
							{territory.name}
						</Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item label="Territory ID" name="territory_id">
				<Input
					placeholder="Select Channel to set Territory ID"
					disabled
					onChange={e => form.setFieldValue("territory_id", getDigitsOnly(e.target.value))}
				/>
			</Form.Item>
			<Form.Item label="Channel" name="channel">
				<Select
					allowClear
					showSearch
					placeholder="Select a channel"
					onChange={value => {
						const [id] = value?.split("_") ?? [];
						id ? form.setFieldValue("channel_id", id) : form.resetFields(["channel_id"]);
					}}
				>
					{channelData.map(channel => (
						<Option key={channel.key} value={`${channel.id}_${channel.name}`}>
							{channel.name}
						</Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item label="Channel ID" name="channel_id">
				<Input
					placeholder="Select Channel to set Channel ID"
					disabled
					onChange={e => form.setFieldValue("channel_id", getDigitsOnly(e.target.value))}
				/>
			</Form.Item>
		</>
	);
};

export default DealGridForm;
